const table = [
	{
		pos: 1,
		name: 'Manchester City',
		played: 38,
		win: 29,
		draw: 6,
		lose: 3,
		f: 99,
		a: 26,
		gd: 73,
		pts: 93,
		last: 'W-W-W-D-W',
	},
	{
		pos: 2,
		name: 'Liverpool',
		played: 38,
		win: 28,
		draw: 8,
		lose: 2,
		f: 94,
		a: 26,
		gd: 68,
		pts: 92,
		last: 'W-D-W-W-W',
	},
	{
		pos: 3,
		name: 'Chelsea',
		played: 38,
		win: 21,
		draw: 11,
		lose: 6,
		f: 76,
		a: 33,
		gd: 43,
		pts: 74,
		last: 'L-D-W-D-W',
	},
	{
		pos: 4,
		name: 'Tottenham Hotspur',
		played: 38,
		win: 22,
		draw: 5,
		lose: 11,
		f: 69,
		a: 40,
		gd: 29,
		pts: 71,
		last: 'W-D-W-W-W',
	},
	{
		pos: 5,
		name: 'Arsenal',
		played: 38,
		win: 22,
		draw: 3,
		lose: 13,
		f: 61,
		a: 48,
		gd: 14,
		pts: 69,
		last: 'W-W-L-L-W',
	},
	{
		pos: 6,
		name: 'Manchester United',
		played: 38,
		win: 16,
		draw: 10,
		lose: 12,
		f: 57,
		a: 57,
		gd: 0,
		pts: 58,
		last: 'L-D-W-L-L',
	},
	{
		pos: 7,
		name: 'West Ham United',
		played: 38,
		win: 16,
		draw: 8,
		lose: 14,
		f: 60,
		a: 51,
		gd: 9,
		pts: 56,
		last: 'L-L-W-D-L',
	},
	{
		pos: 8,
		name: 'Leicester City',
		played: 38,
		win: 14,
		draw: 10,
		lose: 14,
		f: 62,
		a: 59,
		gd: 3,
		pts: 52,
		last: 'L-W-W-D-W',
	},
	{
		pos: 9,
		name: 'Brighton & Hove Albion',
		played: 38,
		win: 12,
		draw: 15,
		lose: 11,
		f: 42,
		a: 44,
		gd: -2,
		pts: 51,
		last: 'D-W-W-D-W',
	},
	{
		pos: 10,
		name: 'Wolverhampton',
		played: 38,
		win: 15,
		draw: 6,
		lose: 17,
		f: 37,
		a: 43,
		gd: -6,
		pts: 51,
		last: 'L-D-L-D-L',
	},
	{
		pos: 11,
		name: 'Newcastle United',
		played: 38,
		win: 13,
		draw: 10,
		lose: 15,
		f: 44,
		a: 62,
		gd: -18,
		pts: 49,
		last: 'W-L-L-W-W',
	},
  {
    pos: 12,
    name: 'Crystal Palace',
    played: 38,
    win: 11,
    draw: 15,
    lose: 12,
    f: 50,
    a: 46,
    gd: 4,
    pts: 48,
    last: 'W-W-D-L-W',
  },
	{
		pos: 13,
		name: 'Brentford',
		played: 38,
		win: 13,
		draw: 7,
		lose: 18,
		f: 48,
		a: 56,
		gd: -8,
		pts: 46,
		last: 'D-L-W-W-L',
	},
	{
		pos: 14,
		name: 'Aston Villa',
		played: 38,
		win: 13,
		draw: 6,
		lose: 19,
		f: 52,
		a: 54,
		gd: -2,
		pts: 45,
		last: 'W-L-D-D-L',
	},
	{
		pos: 15,
		name: 'Southampton',
		played: 38,
		win: 9,
		draw: 13,
		lose: 16,
		f: 43,
		a: 67,
		gd: -24,
		pts: 40,
		last: 'D-L-L-L-L',
	},
	{
		pos: 16,
		name: 'Everton',
		played: 38,
		win: 11,
		draw: 6,
		lose: 21,
		f: 43,
		a: 66,
		gd: -24,
		pts: 39,
		last: 'W-D-L-W-L',
	},
  {
    pos: 17,
    name: 'Leeds United',
    played: 38,
    win: 9,
    draw: 11,
    lose: 18,
    f: 42,
    a: 79,
    gd: -37,
    pts: 38,
    last: 'L-L-L-D-W',
  },
	{
		pos: 18,
		name: 'Burnley',
		played: 38,
		win: 7,
		draw: 14,
		lose: 17,
		f: 34,
		a: 53,
		gd: -19,
		pts: 35,
		last: 'W-L-L-D-L',
	},
	{
		pos: 19,
		name: 'Watford',
		played: 38,
		win: 6,
		draw: 5,
		lose: 27,
		f: 34,
		a: 77,
		gd: -43,
		pts: 23,
		last: 'L-L-D-L-L',
	},
	{
		pos: 20,
		name: 'Norwich City',
		played: 38,
		win: 5,
		draw: 7,
		lose: 26,
		f: 23,
		a: 84,
		gd: -61,
		pts: 22,
		last: 'L-L-L-D-L',
	},
];
export default table;
